import Postmedia from "../../components/postmedia/Postmedia";
import "./postDetail.scss";
import Postdetails from "../../components/postdetails/Postdetails";
import { useParams, useNavigate } from "react-router-dom"; 

const PostDetail = () => {
  const { postId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="detailPost">
        <div className="leftDetailPosts">
          <Postmedia postId={postId} />
        </div>

        <div className="rightDetailPosts">
          <Postdetails postId={postId} />
        </div>
    </div>
  )
}

export default PostDetail;